module.exports = __webpack_public_path__ + "static/media/no-img.7ddb9c9e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/no-img.png
// module id = 334
// module chunks = 0